module.exports = __webpack_public_path__ + "media/concept_job-39cbdd4b14611da8b224cf809587fc26.svg";